import { FileDataInterface } from '@/store/interfaces/filedata.interface';
import LocalStoreService from '@/store/local.store';

export default class BlobConverter {
  public static base64ToBlob(fileContent: any, fileType: any) {
    throw new Error('Method not implemented.');
  }

  public static b64toBlob(b64Data: string, contentType = '', sliceSize = 512): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public static saveBlobToLocalStorage(res: FileDataInterface) {
    const reader = new FileReader();
    LocalStoreService.setItem(LocalStoreService.localItemKeys.followUpFilename, res.name);
    reader.readAsDataURL(res.blob);
    reader.onloadend = () => {
            const base64data = (reader.result as string).replace(/^data:.+;base64,/, '');
            LocalStoreService.setItem(res.name, base64data as string);
          };
  }

  public static fileReader(file: Blob): Promise<string | ArrayBuffer | null> {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onerror = () => {
        reader.abort();
        reject(new Error('Problem parsing file'));
      };

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.readAsText(file);
    });
  }
}
